var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegulation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18036_5107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0V48H48V0H0ZM45.9533 45.9533H3.51667L21.6667 27.79L30.0233 36.15L40.1433 26.03L21.97 7.84333L11.85 17.9633L20.2333 26.3333L2.04667 44.53V2.04667H45.9533V45.9533ZM14.7467 17.9533L21.97 10.7367L23.51 12.2767L16.2833 19.5L14.7467 17.9533ZM24.9567 13.7233L34.3333 23.1067L27.1167 30.3333L17.73 20.9467L24.9567 13.7233ZM37.2633 26.03L30.0367 33.2533L28.5633 31.78L35.7867 24.5533L37.2633 26.03Z",
    fill: "#415385"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18036_5107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegulation);
export default __webpack_public_path__ + "static/media/regulation.17cc7a4636da108acc8fb769c297a8fc.svg";
export { ForwardRef as ReactComponent };